<template>
  <div>
    <ys-data-table
      v-model="refresh"
      :list="searchList"
      :button-list="buttonList"
      :columns="columns"
      :fetch-method="fetchMethod"
      :transform-params="handleFormatSearch"
      page-size-alias="pageSize"
      :page-sizes="[100, 200, 300, 400, 1000]"
      :page-size="1000"
      use-data-field
    >
      <template slot="upload">
        <el-upload
          :action="action"
          name="excel"
          :data="{ origin_id: originId }"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :show-file-list="false"
          with-credentials
        >
          <el-button size="small" type="primary">快递时效导入</el-button>
        </el-upload>
      </template>
      <template slot="log">
        <el-button type="primary" @click="handleDialogOpen">
          修改日志
        </el-button>
      </template>
    </ys-data-table>
    <el-dialog
      title="修改日志："
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleDialogClose"
    >
      <el-table :data="logTableData" border style="width: 100%">
        <el-table-column prop="update_admin" label="更新人" width="180">
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="180">
        </el-table-column>
        <el-table-column prop="file_url" label="更新文件">
          <template slot-scope="scope">
            <i class="el-icon-document" />
            <el-button type="text" @click="handleDownload(scope.row.file_url)">
              下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash-es";
import apiBaseURL from "@/utils/baseUrl.js";

import {
  getShippingCompanyEfficiency,
  getWavePickingBaseShippingCompany,
  getImportShippingCompanyLogList,
} from "@/controller/wavePickingShipping.js";

export default {
  name: "ShippingAgingList",
  props: {
    originId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      mergeForm: {
        origin_id: "",
      },
      columns: [
        {
          label: "省/市/区（县）",
          prop: "whole_name",
        },
        {
          label: "标准时效（小时）",
          prop: "standard_time",
        },
        {
          label: "向下容忍值（%）",
          prop: "tolerance_value",
        },
      ],
      dialogVisible: false,
      fetchMethod: getShippingCompanyEfficiency,
      buttonList: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: (params) =>
              getShippingCompanyEfficiency({ ...params, is_excel: "1" }),
            success: (res) => window.open(apiBaseURL + res.file),
          },
        },
        {
          tag: "custom",
          slot: "upload",
        },
        {
          tag: "custom",
          slot: "log",
        },
      ],
      searchList: [],
      refresh: false,
      logTableData: [],
      action: `${apiBaseURL}/erp/WavePickingShipping/importShippingCompanyEfficiency`,
    };
  },
  watch: {
    originId(val) {
      this.mergeForm.origin_id = val;
      this.refresh = true;
    },
  },
  created() {
    this.mergeForm.origin_id = this.originId;
    this.getColumns();
    this.refresh = true;
  },
  methods: {
    handleFormatSearch(params) {
      const result = {
        ...this.mergeForm,
        ...params,
      };
      return result;
    },
    // 获取所有快递公司表头
    getColumns() {
      getWavePickingBaseShippingCompany().then((data) => {
        this.shippingCompanyOptions = data;
        const columnsArr = data.map((item) => {
          return {
            label: `${item.shipping_company}-达标率（%）`,
            prop: item.table_pre,
          };
        });
        const columnsClone = cloneDeep(this.columns);
        columnsClone.splice(4, 0, ...columnsArr);
        this.columns = columnsClone;
      });
    },
    handleUploadSuccess(data) {
      if (data.code !== 200) {
        this.$message.error(data.msg);
      } else {
        this.$message.success("导入成功");
        if ((data.data || {}).file) {
          window.open(apiBaseURL + data.data.file);
        }
      }
    },
    handleUploadError() {
      this.$message.warning("导入失败！");
    },
    // 查看日志
    handleDialogOpen() {
      getImportShippingCompanyLogList({ origin_id: this.originId }).then(
        (data) => {
          this.logTableData = data;
          this.dialogVisible = true;
        }
      );
    },
    handleDialogClose() {
      this.dialogVisible = false;
    },
    handleDownload(fileUrl) {
      window.open(fileUrl);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/wavepicking/ShippingRule/components/ShippingAgingList.vue